import React, { useState } from "react";
import "../css/SchoolCampus.css";

const campusData = {
  India: [
    {
      name: "Nagpur",
      image:
        "https://images.unsplash.com/photo-1562774053-701939374585?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Pune - Hadapsar",
      image:
        "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Pune - Balewadi",
      image:
        "https://images.unsplash.com/photo-1577896851231-70ef18881754?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Noida",
      image:
        "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=900&auto=format&fit=crop&q=80",
    },
  ],

  Singapore: [
    {
      name: "East Coast Campus",
      image:
        "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Punggol Campus",
      image:
        "https://images.unsplash.com/photo-1519452575417-564c1401ecc0?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Balestier Campus",
      image:
        "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "SMART Campus",
      image:
        "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Ahmedabad",
      image:
        "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Bengaluru",
      image:
        "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Hyderabad",
      image:
        "https://images.unsplash.com/photo-1513258496099-48168024aec0?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Chennai",
      image:
        "https://images.unsplash.com/photo-1562774053-701939374585?w=900&auto=format&fit=crop&q=80",
    },
  ],

  UAE: [
    {
      name: "Dubai Campus",
      image:
        "https://images.unsplash.com/photo-1518005020951-eccb494ad742?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Abu Dhabi Campus",
      image:
        "https://images.unsplash.com/photo-1460317442991-0ec209397118?w=900&auto=format&fit=crop&q=80",
    },
  ],

  Japan: [
    {
      name: "Tokyo Campus",
      image:
        "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Yokohama Campus",
      image:
        "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=900&auto=format&fit=crop&q=80",
    },
  ],

  Malaysia: [
    {
      name: "Kuala Lumpur",
      image:
        "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Cyberjaya",
      image:
        "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=900&auto=format&fit=crop&q=80",
    },
  ],

  Thailand: [
    {
      name: "Bangkok Campus",
      image:
        "https://images.unsplash.com/photo-1513258496099-48168024aec0?w=900&auto=format&fit=crop&q=80",
    },
    {
      name: "Phuket Campus",
      image:
        "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=900&auto=format&fit=crop&q=80",
    },
  ],
};

export default function SchoolCampus() {
  const tabs = Object.keys(campusData);

  const [activeTab, setActiveTab] = useState("India");

  return (
    <section className="school-campus">
      <div className="campus-heading">
        <h2>Our International School Campuses</h2>

        <h4>One of India's Top GIIS Schools in Ahmedabad</h4>

        <p>
          GIIS Ahmedabad proudly stands as one of India's top schools, offering
          exceptional education and holistic development opportunities to
          students. With a strong commitment to academic excellence,
          state-of-the-art facilities and a nurturing environment.
        </p>
      </div>

      <div className="campus-wrapper">
        <div className="campus-tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`campus-tab ${activeTab === tab ? "active" : ""}`}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="campus-grid">
          {campusData[activeTab].map((campus, index) => (
            <div className="campus-card" key={index}>
              <div className="campus-image">
                <img src={campus.image} alt={campus.name} />
              </div>

              <div className="campus-content">
                <h3>{campus.name}</h3>

                <button className="campus-btn">Explore Campus</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
